module.exports = "<div class=row><div class=col-lg-12><div class=page-header><h1>Not Found</h1></div></div></div><div class=\"row dashboard-content\"><div class=col-lg-12>The page you are looking for cannot be found. Take a break before trying again.<br><br><br><br></div><pre class=\"ascii col-lg-offset-4 col-lg-4 col-md-offset-3 col-md-6 col-sm-offset-2 col-sm-8 col-cs-offset-1 col-xs-10\">\n\n       |\\      _,,,---,,_\n       /,`.-'`'    -.  ;-;;,_\n      |,4-  ) )-,_..;\\ (  `'-'\n     '---''(_/--'  `-'\\_)\n\n    </pre></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/javascripts/ng-admin/Main/view/404.html
 ** module id = 159
 ** module chunks = 0 1
 **/